import currentWidgetDetails from "utilities/platform/widget-details";
import smoothscroll from "utilities/global/sparta-polyfill-utility/1.5.1/js/smoothscroll";
(function polyfill() {




  if (!Array.prototype.findIndex) {
    Array.prototype.findIndex = function(predicate) {
      'use strict';
      if (this == null) {
        throw new TypeError('Array.prototype.findIndex called on null or undefined');
      }
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }
      var list = Object(this);
      var length = list.length >>> 0;
      var thisArg = arguments[1];
      var value;

      for (var i = 0; i < length; i++) {
        value = list[i];
        if (predicate.call(thisArg, value, i, list)) {
          return i;
        }
      }
      return -1;
    };
  }





  if (!window.console) {
    window.console = {
      log: function() {},
      debug: function() {}
    };
  }





  if ( typeof window.CustomEvent !== "function" ) {
    function CustomEvent ( event, params ) {
      params = params || { bubbles: false, cancelable: false, detail: undefined };
      var evt = document.createEvent( 'CustomEvent' );
      evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
      return evt;
     }

    CustomEvent.prototype = window.Event.prototype;
    window.CustomEvent = CustomEvent;
  }





  if (window.Element && !Element.prototype.closest) {
    Element.prototype.closest =
    function(s) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(s),
            i,
            el = this;
        do {
            i = matches.length;
            while (--i >= 0 && matches.item(i) !== el) {};
        } while ((i < 0) && (el = el.parentElement));
        return el;
    };
  }





  if (!Element.prototype.matches) {
    Element.prototype.matches =
      Element.prototype.matchesSelector ||
      Element.prototype.mozMatchesSelector ||
      Element.prototype.msMatchesSelector ||
      Element.prototype.oMatchesSelector ||
      Element.prototype.webkitMatchesSelector ||
      function(s) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(s),
          i = matches.length;
        while (--i >= 0 && matches.item(i) !== this) {}
        return i > -1;
      };
  }


  if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
      value: function(predicate) {

        if (this == null) {
          throw new TypeError('"this" is null or not defined');
        }

        var o = Object(this);


        var len = o.length >>> 0;


        if (typeof predicate !== 'function') {
          throw new TypeError('predicate must be a function');
        }


        var thisArg = arguments[1];


        var k = 0;


        while (k < len) {




          var kValue = o[k];
          if (predicate.call(thisArg, kValue, k, o)) {
            return kValue;
          }

          k++;
        }


        return undefined;
      },
    });
  }




  ;(function(constructor) {
    if (constructor &&
        constructor.prototype &&
        constructor.prototype.children == null) {
          try {
            Object.defineProperty(constructor.prototype, 'children', {
              get: function() {
                try {
                  var i = 0, node, nodes = this.childNodes, children = [];
                  while (node = nodes[i++]) {
                      if (node.nodeType === 1) {
                          children.push(node);
                      }
                  }
                  return children;
                } catch (e) {
                  return [];
                }
              }
          });
          } catch (e) {}
    }
  })(window.Node || window.Element);

    (function (arr) {
    arr.forEach(function (item) {
      if (item.hasOwnProperty('remove')) {
        return;
      }
      Object.defineProperty(item, 'remove', {
        configurable: true,
        enumerable: true,
        writable: true,
        value: function remove() {
          if (this.parentNode !== null)
            this.parentNode.removeChild(this);
        }
      });
    });
  })([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

  })();
